import React from 'react'
import { connect } from 'react-redux';
import { stockActions } from '@/actions/trading/stock.action';
import { ACTION_TYPE } from "@/constants/w-socket";
import { Icons} from '@/configurations';
import '../../assets/styles/components/instrument/bid-ask.scss';
import { formatFunctions, Converter } from '@/helpers/functions';
import { dataType } from '@/constants/data-type';
import classnames from 'classnames';
class BidAsk extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bidData: Array(10).fill({ price: '-', qty: '-' }),
      askData: Array(10).fill({ price: '-', qty: '-' }),
      bidAllQtyRate: '',
      askAllQtyRate: '',
      isblock : false,
      bidRatePrecent : '',
      askRatePrecent : ''
    }
  }
  render() {
    const { language, handleQueueItemClick } = this.props;
    const { bidData, askData, bidAllQtyRate, askAllQtyRate , isblock , bidRatePrecent , askRatePrecent} = this.state;
    return (
      <div className={classnames("bid-ask-container",isblock ? 'open' : 'close')}>
        {/* <header>
          <span>{language.common_best_bid}</span>
          <span>{language.common_best_ask}</span>
        </header> */}
        <div className="percent">
          <div style={{ minWidth: `${bidAllQtyRate ? bidRatePrecent : 50}%` }}>
            <span>{language.trade_bid}</span>
            <span>{bidAllQtyRate ? bidAllQtyRate : 50}%</span>
          </div>
          <div style={{ minWidth: `${askAllQtyRate ? askRatePrecent : 50}%` }}>
            <span>{askAllQtyRate ? askAllQtyRate : 50}%</span>
            <span>{language.trade_ask}</span>
          </div>
        </div>
        <section>
          <div className="item-list bid-list">
            {bidData.map((bid, index) =>
              <div key={`${bid.price}${index}`} className="item" onClick={() => handleQueueItemClick(bid, true)}>
                <div className="item_label">{`${++index}`}</div>
                <div className="item-content">
                  <span>{formatFunctions.dataFormat(bid.price, dataType.CURRENCY) || '-'}</span>
                  <span>({bid.qty === 0 ? 0 : this.formatNumber(formatFunctions.dataFormat(bid.qty, dataType.NUMBER)) || '--'})</span>
                </div>
              </div>
            )}
          </div>
          <div className="item-list ask-list">
            {askData.map((ask, index) =>
              <div key={`${ask.price}${index}`} className="item" onClick={() => handleQueueItemClick(ask, false)}>
              <div className="item-content">
                <span>
                ({ask.qty === 0 ? 0 :this.formatNumber(formatFunctions.dataFormat(ask.qty, dataType.NUMBER)) || '--'})
                </span>
                <span>{formatFunctions.dataFormat(ask.price, dataType.CURRENCY) || '-'}</span>
              </div>
              <div className="item_label">{`${++index}`}</div>
            </div>
            )}
          </div>
        </section>
        {bidData.length >= 10  && (
          <div className='view-btn' onClick={this.viewDetails}>
            <div className='view-details-quote'> 
              <span>{isblock ? language.view_5_details_quote : language.view_10_details_quote}</span>
            </div>
            <div className='view-details-icon'>
              {isblock ? <Icons.ArrowUp size={16}/> : <Icons.ArrowDown size={16}/>}
            </div>
            <div className='ramaining-times'>
              <span>{language.trade_remaining_times} 500</span>
            </div>
          </div>
        )}
      </div>
    )
  }

  viewDetails=()=>{
    const isblock = this.state.isblock
    this.setState({isblock : !isblock})
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return
    }
  }

  formatNumber = (num) => {
    if (!num) return
    let numArr = String(num).split(',')
    if (numArr.length === 2) {
      return `${numArr[0]}${numArr[1] === '000' ? '' : '.' + numArr[1]}K`
    } else {
      return num
    }
  }

  getDetailData = async() => {
    const { marketParams, language, mdsToken,currentTradingAccount } = this.props;
    const { clientID, tradingAccSeq } = currentTradingAccount

    if (!(marketParams.stockCode && mdsToken)) {
      return
    }

    const getDetailDataTimeOutFunc = () => {
      this.setState({
        bidData: Array(10).fill({ price: '-', qty: '-' }),
        askData: Array(10).fill({ price: '-', qty: '-' }),
        bidAllQtyRate: '',
        askAllQtyRate: '',
      })
    }

    clearTimeout(this.getDetailDataTimeOutRef)
    this.getDetailDataTimeOutRef = setTimeout(getDetailDataTimeOutFunc, 8000)

    const renderPriceInfoFunc = res => {
      clearTimeout(this.getDetailDataTimeOutRef)
      if (Array.isArray(res['bids']) && Array.isArray(res['asks']) && (res['bids'].length || res['asks'].length)) {
        if (res.bids.length > 0 || res.asks.length > 0) {
          let bid = res.bids.slice(0, 10);
          let ask = res.asks.slice(0, 10);
          let bidAllQty = this.state.bidData;
          let askAllQty = this.state.askData;
          if (res.bids.length > 0) {
            bidAllQty = res.bids.reduce((total, num) => {
              if (total instanceof Object) {
                return total.qty + num.qty
              } else {
                return total + num.qty
              }
            }, 0);
          }

          if (res.asks.length > 0) {
            askAllQty = res.asks.reduce((total, num) => {
              if (total instanceof Object) {
                return total.qty + num.qty
              } else {
                return total + num.qty
              }
            }, 0);
          }

          let bidAllQtyRate, askAllQtyRate

          if (bidAllQty === 0 && askAllQty === 0) {
            bidAllQtyRate = '0.00'
            askAllQtyRate = '0.00'
            this.setState({bidRatePrecent : 50 , askRatePrecent : 50})
          } else {
            bidAllQtyRate = parseFloat((bidAllQty / (bidAllQty + askAllQty)) * 100).toFixed(2)
            askAllQtyRate = parseFloat((askAllQty / (bidAllQty + askAllQty)) * 100).toFixed(2)
            if(bidAllQtyRate && bidAllQtyRate < 20 ){
              this.setState({bidRatePrecent : 22 , askRatePrecent : 78})
            }else if(askAllQtyRate && askAllQtyRate < 20 ){
              this.setState({bidRatePrecent : 78 , askRatePrecent : 22})
            }else{
              this.setState({bidRatePrecent : bidAllQtyRate , askRatePrecent : askAllQtyRate})
            }
          }
          this.setState({
            bidData: bid,
            askData: ask,
            bidAllQtyRate,
            askAllQtyRate,
          })
          this.props.setBidAskData(bid,ask)
        }

      } else {
        getDetailDataTimeOutFunc()
      }
    }

    let params = {
      symbols: [
        {
          exchangeID: Converter.mappingWebSocketMarket(marketParams.marketID),
          key: Converter.mappingStockCode(marketParams.stockCode)
        }
      ],
      sessID: mdsToken
    }

    if (params.symbols[0].exchangeID === 'XNYS') {
      stockActions.getAggregateOrderBookAction(params, renderPriceInfoFunc)
    } else {
      this.props.getDetailPriceInfoData(params, renderPriceInfoFunc)
    }
  }
  
  componentDidMount() {
    this.getDetailData()
  }

  componentDidUpdate(preProps) {
    const { marketParams, mdsToken } = this.props;
    if (marketParams && JSON.stringify(preProps.marketParams) !== JSON.stringify(marketParams) || preProps.mdsToken !== mdsToken) {
      this.getDetailData()
    }

    // if (mdsToken && preProps.mdsToken !== mdsToken) {
    //   this.getDetailData()
    // }
  }
}

BidAsk.defaultProps = {
  handleQueueItemClick: () => {}
}

export default connect(
  state => ({
    language: state.app.language,
    marketParams: state.trade.marketParams,
    mdsToken: state.trade.mdsToken,
    currentTradingAccount: state.trade.currentTradingAccount,
  }),
  dispatch => ({
    getDetailPriceInfoData: (p, c) => dispatch(stockActions.getDetailPriceInfoAction(p, c)),
    // loginMDS: (p, c) => dispatch(stockActions.loginMDSAction(p, c))
  })
)(BidAsk)
